import React from 'react';
import clsx from 'clsx';
import { Modal } from 'react-bootstrap';

import styles from './styles.module.scss';

export const CustomModal = (
    {
        children,
        show,
        onClose,
        title,
        className,
    }: 
    {
        children: any
        show: boolean
        className?: any
        onClose: any
        title?: string
    }
) => {
    return (
        <Modal
            centered
            show={show}
            onHide={onClose}
            className={clsx(className)}
        >
            <div className={styles.modal}>
                <div
                    className={styles.modalBody}
                >
                    <div
                        className='d-flex flex-column'
                    >
                        <div className='d-flex justify-content-between align-items-center my-2'>
                            <h4 className={clsx(styles.title, 'text-white')}>{ title ? title : 'SELECT TOKEN' }</h4>
                            <i
                                onClick={onClose}
                                className={clsx(styles.close, 'fa-regular fa-xmark')}
                            />
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </Modal>
    );
};
